import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { article } from "@Api";
import { Switch } from "antd";
import { g4 } from "../../../../utils/helper";
import Item from "./item";
import { host } from "@Services/url";

const { fetchV3Articles } = article;

const RecommendMovieList = ({ info, height, nextAutoPlay }) => {
  const [list, setList] = useState<any>([]);
  const playStatus = Boolean((localStorage as any).getItem("play_status")) != false;

  useEffect(() => {
    getRecommendMovieList();
  }, []);

  useEffect(() => {
    if (nextAutoPlay && list.length > 0 && playStatus) {
      const index = Number(new URL(location.href).searchParams.get("currentIndex"));
      window.open(`${host.c}/movies/${list[index].hasOwnProperty("id") ? list[index].id : list[0].id}?currentIndex=${index + 1}`, "_blank");
    }
  }, [nextAutoPlay]);

  const getRecommendMovieList = async () => {
    const kindsList = [...info.kinds, ...info.completeKinds];
    const idsList = kindsList.map((item) => {
      return item.kind_id;
    });

    const params = {
      limit: 100,
      type: "3",
      contentType2: info.data.movieCategoryInfo.title,
      filterIds: window.movie_id || 0,
    };
    const res = await fetchV3Articles(params);

    if (res && res.status === 12000) {
      setList(res.data.list);
    }
  };

  const getMovieList = async (params) => {
    const res = await fetchV3Articles(params);

    if (res && res.status === 12000) {
      return res.data.list;
    }
  };

  const _onChange = (status) => {
    localStorage.setItem("play_status", status);
  };

  return (
    <>
      {Array.isArray(list) && list.length > 0 && (
        <section className={styles["RecommendMovieList"]}>
          <div className={styles["header"]}>
            <div className={styles["continuous-play"]}>
              <span>連續播放</span>
              <Switch
                className={styles["switch-btn"]}
                size='small'
                defaultChecked={playStatus}
                onChange={(status) => _onChange(status)}
              />
            </div>
          </div>

          <div className={styles["list"]} style={{ height }}>
            {list.map((v, i) => (
              <Item data={v} key={i} index={i} />
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default RecommendMovieList;
